
import {
  Component, Mixins, Prop,
} from 'vue-property-decorator';
import TaskEditDialog from '@/components/TaskEditDialog.vue';
import AttachmentsList from '@/components/AttachmentsList.vue';
import DialogMixin from '@/mixins/DialogMixin.vue';
import UtilsMixin from '@/mixins/UtilsMixin.vue';
import { AttachmentType, AttachmentTypeOptions, Task } from '@/types';

@Component({
  components: {
    TaskEditDialog,
    AttachmentsList,
  },
})
export default class TaskAttachmentsDialog extends Mixins(DialogMixin, UtilsMixin) {
  // Array dei tipi di allegato
  @Prop({ type: Array, default: () => [] }) readonly types!: string[];

  // Se true, usa un'unica AttachmentsList con tutti i tipi invece di liste separate
  @Prop({ type: Boolean, default: false }) readonly useSingleList!: boolean;

  // Titolo da usare quando useSingleList è true (opzionale)
  @Prop({ type: String, default: null }) readonly singleListTitle!: string | null;

  // Tipo preferito per lo split button in AttachmentsList
  @Prop({ type: String, default: null }) readonly preferredType!: AttachmentType | null;

  // Titolo del dialog (opzionale)
  @Prop({ type: String, default: 'Allegati al Task' }) readonly title!: string;

  // Il Task selezionato memorizzato tramite Vuex
  get selectedTask(): Task | null {
    return this.$store.getters.selectedTask;
  }

  get availableTypes(): string[] {
    return this.types.filter((t) => this.hasPermission(`attachments.${t}.ignore_task_status`));
  }

  // Titolo combinato generato automaticamente dai nomi dei tipi
  get combinedTitle(): string {
    const typeNames = this.types
      .map((t) => this.attachmentTypeName(t))
      .filter((name) => name !== 'Sconosciuto');
    return typeNames.length > 0
      ? typeNames.join(', ')
      : 'Allegati';
  }

  attachmentTypeName(type: string): string {
    return type in AttachmentTypeOptions
      ? AttachmentTypeOptions[type]
      : 'Sconosciuto';
  }
}
